export default __webpack_public_path__ + "static/students-5d49ebf73b2dfd5bf4a990c66c072d19.mp4";